import { render, staticRenderFns } from "./cusHeader.vue?vue&type=template&id=b004b2cc"
import script from "./cusHeader.vue?vue&type=script&lang=js"
export * from "./cusHeader.vue?vue&type=script&lang=js"
import style0 from "./cusHeader.vue?vue&type=style&index=0&id=b004b2cc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports